var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center",class:[_vm.captionPosition, 'silver-button-'+_vm.borderColor],on:{"click":_vm.doClick}},[(!_vm.loading)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.caption)}}):_c('b-spinner',{attrs:{"small":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }